/**
 * Created by mcochrane on 25/08/17.
 */
import { CompInst } from './CompInst'
// import {guid} from './helpers'
import _ from 'lodash'
import Vue from 'vue'
import store from '../../store'

// Array of component instances (CompInst objects)
var _cmpInsts = []
var maxCmpId = 0

window._cmpInsts = _cmpInsts
// window._skipMdRender = false
window.findComponentWithName = findComponentWithName

function makeName () {
  return 'cmp_' + (maxCmpId++).toString()
}

export function findAllComponentsWithType (componentType) {
  return _cmpInsts.filter(comp => comp.cmpDef.type === componentType)
}

export function findComponent (match, index, componentType) {
  for (var i = 0; i < _cmpInsts.length; i++) {
    if (_cmpInsts[i].equalsMatch(match, index, componentType)) {
      return _cmpInsts[i]
    }
  }
  return null
}

export function findComponentWithName (name) {
  for (var i = 0; i < _cmpInsts.length; i++) {
    if (_cmpInsts[i].name === name) {
      return _cmpInsts[i]
    }
  }
  return null
}

export function compileComponent (cmpnt, match, matchIndex, note, subMatches, saveFunc) {
  let cmp = makeNewComponent(cmpnt, match, matchIndex, note, subMatches, saveFunc)
  Vue.set(_cmpInsts, _cmpInsts.length, cmp)
  // _cmpInsts.push(cmp)
  store.commit('addComponentInstance', cmp)
  return cmp
}

export function makeNewComponent (cmpnt, match, matchIndex, note, subMatches, saveFunc) {
  let name = makeName()
  return new CompInst(match, matchIndex, name, note, cmpnt, subMatches, saveFunc)
}

export function deleteComponent (cmpnt) {
  cmpnt.deleteJsFromDOM()
  _.remove(_cmpInsts, cmp => {
    return cmp === cmpnt
  })
  store.commit('removeComponentInstance', cmpnt.name)
}

/**
 * Updates component scripts in the DOM.
 */
export function updateComponentScriptsInDOM () {
  _cmpInsts.forEach(function (cmp) {
    if (cmp.scriptNode == null) {
      cmp.writeJsToDOM()
    }
  })
}

/**
 * Updates component Html in the DOM.
 */
export function updateComponentHtmlInDOM () {
  // This is called before the actual HTML is updated.  We have the new HTML generated (with placeholders but not
  // the real component HTML yet) but it's not in the document (and won't be until next tick).  We want to find
  // the component's HTML elements now and save them.  Then replace them in the next tick!  This is because Vue
  // doesn't use the same element, it creates a replica and replaces it.  So the placeholder span we create in
  // cmp.writeHtmlToDOM() is completely replaced by Vue when we call new Vue({el: placholder}).  Now we need to
  // find that element and use it as the replacement.  Alternatively, we could leave this unchanged and instead,
  // update the component's htmlNode property with the one that Vue replaced it with in Vue.mounted()
  _cmpInsts.forEach(function (cmp) {
    if (cmp.htmlNode === null) {
      cmp.writeHtmlToDOM()
    } else {
      cmp.updateHtmlInDOM()
    }
  })
}

/**
 * Delete all previously parsed component's js from the DOM.
 */
export function deleteAllJsFromDom () {
  _cmpInsts.forEach(function (item) {
    item.deleteJsFromDOM()
  })
}

export function setCurrentComponentInstances (curCmpInsts) {
  _cmpInsts = curCmpInsts
  window._cmpInsts = _cmpInsts
}

/**
 * Deletes all component instances.
 * Deletes their js from the DOM if it has been attached.
 */
export function resetAllComponentInstances () {
  deleteAllJsFromDom()
  // deleteAllCssFromDom();
  _cmpInsts = []
  window._cmpInsts = _cmpInsts
  // TODO[ ]: delete old DOM scripts
}

/**
 * Returns an array of all CompInst instances
 * @return {Array} or CompInst's.
 * @see CompInst
 */
export function getAllComponentInstances () {
  return _cmpInsts
}

/**
 * Returns the last component instance added.
 * @return CompInst
 */
export function getLastComponentInstance () {
  return _cmpInsts[_cmpInsts.length - 1]
}

// window.components = {
//     findComponentWithName: findComponentWithName
// };
